module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared-components/back-button/back-button.component.scss
// module id = ./src/app/shared-components/back-button/back-button.component.scss
// module chunks = main